module.exports = __webpack_public_path__ + "img/menu-hair-11.1ad4ae0b.webp";